// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bhy_a bhy_x bhy_j bhy_u bhy_bc bhy_ql bhy_vv"};